import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as settings from "../../lib/air-api-constant";
import { CommonService } from '../common/common.service';
import { Subject, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {
  private startDate: string;
  private endDate: string;

  private exceptionTypeStatusPromise = new BehaviorSubject<any>({ exceptionType: "All", status: "Open" });
  public $exceptionTypeStatus = this.exceptionTypeStatusPromise.asObservable();

  private exceptionDateRangePromise = new BehaviorSubject<any>(null);
  public $exceptionDateRange = this.exceptionDateRangePromise.asObservable();

  private excetionShipmentIdPromise = new BehaviorSubject<any>(null);
  public $excetionShipmentId = this.excetionShipmentIdPromise.asObservable();

  constructor(protected http: HttpClient,
    protected commonService: CommonService) {
    this.endDate = this.commonService.getCurrentDate();
    this.startDate = this.commonService.getMonthDifference(1);
  }

  updateExceptionTypeStatus(exceptionType: any, status: any) {
    this.exceptionTypeStatusPromise.next({ exceptionType: exceptionType, status: status })
  }

  updateExceptionDateRange(fromDate: any, toDate: any) {
    this.exceptionDateRangePromise.next({ fromDate: fromDate, toDate: toDate })
  }

  updateExceptionShipmentId(shipmentId: any) {
    this.excetionShipmentIdPromise.next(shipmentId);
  }

  getExceptionStatistics(exceptionFilters: any) {
    let body = {
      groupCode: exceptionFilters.groupCode,
      category: exceptionFilters.category,
      timeframe: exceptionFilters.timeframe,
      originRegion:exceptionFilters.originregion,
      destinationRegion:exceptionFilters.destinatinregion,
      bdpServiceCode:exceptionFilters.ServiceCode,
      odsSourceIssue: 0,
      carrierIssue: 0,
      outOfScope: 0,
    }
    exceptionFilters.source.map((item:any) => {
      switch (item) {
        case 2: body.odsSourceIssue = 1; break;
        case 1: body.carrierIssue = 1; break;
        case 0: body.outOfScope = 1; break;
      }
    })
    let url = settings.UserEndPoint.Exception.GET_EXCEPTION_STATISTICS;
    return this.http.post<any>(url, body);
  }

  getExceptionList(body: any = {}) {
    body.source.map((item:any) => {
      switch (item) {
        case 2: body.odsSourceIssue = 1; break;
        case 1: body.carrierIssue = 1; break;
        case 0: body.outOfScope = 1; break;
      }
    })

    if (body.status == 'Ignored' || body.status == 'Resolved') {
      body.odsSourceIssue = 1
      body.carrierIssue = 1
      body.outOfScope = 1
    }
    delete body.source
   // console.log(body)
    let url = settings.UserEndPoint.Exception.GET_EXCEPTION_LIST;
    return this.http.post<any>(url, body);
  }

  updateExceptionStatus(data: any = {}) {
    let url = settings.UserEndPoint.Exception.UPDATE_EXCEPTION_STATUS;
    return this.http.post<any>(url, data);
  }
  //Changed the body for the download exception list.
  downloadExceptionFile(exceptionFilters: any, exceptionType: string, status: string, fromDate:any, toDate:any, companies:any) {
    let body: any;
    switch (status) {
      case 'Ignored': {
        body = {
          companies: companies,
          category: 0,
          timeframe: 0,
          odsSourceIssue: 0,
          carrierIssue: 0,
          outOfScope: 0,
          download: 1,
          limit: -1,
          exceptionType: exceptionType,
          status: status,
          fromDate: fromDate,
          toDate: toDate,
      originRegion:exceptionFilters.originregion,
      destinationRegion:exceptionFilters.destinatinregion,
      bdpServiceCode:exceptionFilters.ServiceCode
        }
        exceptionFilters.source.map((item:any) => {
          switch (item) {
            case 2: body.odsSourceIssue = 1; break;
            case 1: body.carrierIssue = 1; break;
            case 0: body.outOfScope = 1; break;
          }
        })
        break;
      }
      case 'Resolved': {
        body = {
          companies: companies,
          category: 0,
          timeframe: 0,
          odsSourceIssue: 0,
          carrierIssue: 0,
          outOfScope: 0,
          download: 1,
          limit: -1,
          exceptionType: exceptionType,
          status: status,
          fromDate: fromDate,
          toDate: toDate,
      originRegion:exceptionFilters.originregion,
      destinationRegion:exceptionFilters.destinatinregion,
      bdpServiceCode:exceptionFilters.ServiceCode
        }
        exceptionFilters.source.map((item:any) => {
          switch (item) {
            case 2: body.odsSourceIssue = 1; break;
            case 1: body.carrierIssue = 1; break;
            case 0: body.outOfScope = 1; break;
          }
        })
        break;
      }

      default: {
        body = {
          companies: companies,
          category: exceptionFilters.category,
          timeframe: exceptionFilters.timeframe,
          odsSourceIssue: 0,
          carrierIssue: 0,
          outOfScope: 0,
          download: 1,
          limit: -1,
          exceptionType: exceptionType,
          status: status,
          fromDate: fromDate,
          toDate: toDate,
      originRegion:exceptionFilters.originregion,
      destinationRegion:exceptionFilters.destinatinregion,
      bdpServiceCode:exceptionFilters.ServiceCode
        }
        exceptionFilters.source.map((item:any) => {
          switch (item) {
            case 2: body.odsSourceIssue = 1; break;
            case 1: body.carrierIssue = 1; break;
            case 0: body.outOfScope = 1; break;
          }
        })
        break;
      }
    }

    let url = settings.UserEndPoint.Exception.DOWNLOAD_EXCEPTION_FILE;
    const headers: any = { responseType: "blob" };
    return this.http.post<any>(url, body, headers);
  }

  getExceptionFilterOptions() {
    return this.http.get(settings.UserEndPoint.Exception.GET_EXCEPTION_FILTER_OPTIONS);
  }

  public getExTableHeader() {
    return [
      { header: "BDP Reference No.", field: "bdpReference", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Shipment Last Processed", field: "lastProcessdOn", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Event Manager", field: "eventManager", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Multi shipment update", field: "multiShipmentUpdate", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "BDP Representative Name", field: "bdpRepresentativeName", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      //US#5603
      { header: "BDP Service Code", field: "bdpServiceCode", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "BOL", field: "bol", editable: false, isDisabled: false, exceptionType: "BOL", isDefault: true },
      { header: "Booking No.", field: "booking", editable: false, isDisabled: false, exceptionType: "BOL_AND_BOOKING", isDefault: true },
      { header: "Cargo Type", field: "cargoType", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Carrier SCAC", field: "carrierScac", editable: false, isDisabled: false, exceptionType: "SCAC", isDefault: true },
      { header: "Container Count", field: "containerCount", editable: false, isDisabled: false, exceptionType: "CONTAINER_COUNT", isDefault: true },
      { header: "Container Id", field: "containerId", editable: false, isDisabled: false, exceptionType: "CONTAINERS", isDefault: true },
      { header: "Date of Error", field: "dateOfError", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Error Reason", field: "errorReason", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Error Type", field: "exceptionType", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Group Name", field: "groupName", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Last Sent On", field: "lastTriggeredOn", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Master BOL", field: "masterBol", editable: false, isDisabled: false, exceptionType: "BOL", isDefault: true },
      { header: "Master Booking No.", field: "masterBooking", editable: false, isDisabled: false, exceptionType: "BOL_AND_BOOKING", isDefault: true },
      { header: "Master Carrier SCAC", field: "masterCarrierScac", editable: false, isDisabled: false, exceptionType: "SCAC", isDefault: true },
      { header: "Port of Arr. Est.", field: "portOfArrivalEstimate", editable: false, isDisabled: false, exceptionType: "DATE_DIFFERENTIAL", isDefault: true },
      { header: "Port of Arrival UNLOC", field: "portOfArrivalUnl", editable: false, isDisabled: false, exceptionType: "PORTS", isDefault: true },
      { header: "Port of Departure UNLOC", field: "portOfDepartureUnl", editable: false, isDisabled: false, exceptionType: "PORTS", isDefault: true },
      { header: "Port of Dept. Est.", field: "portOfDepartureEstimate", editable: false, isDisabled: false, exceptionType: "DATE_DIFFERENTIAL", isDefault: true },
      { header: "Resolution Date", field: "resolutionDate", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Resolved By", field: "resolvedBy", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Source System", field: "sourceSystemDescription", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Source System Region", field: "region", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Source of Error", field: "sourceOfError", editable: false, isDisabled: false, exceptionType: null, isDefault: true },
      { header: "Status", field: "status", editable: false, isDisabled: true, exceptionType: null, isDefault: true },
      { header: "Transship Arr. Est.", field: "transshipArrivalEstimate", editable: false, isDisabled: false, exceptionType: "DATE_DIFFERENTIAL", isDefault: true },
      { header: "Transship Dept. Est.", field: "transshipDepartureEstimate", editable: false, isDisabled: false, exceptionType: "DATE_DIFFERENTIAL", isDefault: true },
      { header: "Vessel Name", field: "vesselName", editable: false, isDisabled: false, exceptionType: "VESSEL_NAME", isDefault: true },
     
    ];
  }
}
